<template>
  <a-card :bordered="false">
    <a-spin :spinning="loading">
      <a-form :form="form">
        <a-row>
          <a-col offset="1" :span="21" v-if="otherData.product_parameters.length > 0">
            <a-divider orientation="left">
              购销合同关联产品： {{ product_name }}
            </a-divider>
            <a-table
              bordered
              :data-source="otherData.product_parameters"
              :columns="parameterColumns"
              v-if="this.otherData.product_parameters.length > 0"
              :pagination="false"
              rowKey="id">
              <span slot="serial" slot-scope="text, record, index">
                {{ index + 1 }}
              </span>
              <template slot="value" slot-scope="text, record">
                <div>
                  <a-input-number
                    :precision="4"
                    :value="text"
                    placeholder="实际值"
                    @change="e => handleItemChange(e, record.key, 'value')"/>
                </div>
              </template>
            </a-table>
          </a-col>
          <a-col offset="1" :span="21">
            <a-divider orientation="left">
              结算基础信息
            </a-divider>
          </a-col>
          <a-col :span="12">
            <a-form-item label="系统编号" :label-col="labelCol" :wrapper-col="wrapperCol">
              <a-input v-decorator="['number', {rules: [{required: true, message: '必填项，请填写信息'}, {max:32, message: '输入超出长度限制'}]}]" disabled/>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="false">
            <a-form-item label="购销合同" :label-col="labelCol" :wrapper-col="wrapperCol">
              <a-select
                v-decorator="[
                  'sell_contract_id',
                  {
                    rules: [
                      { required: true, message: '请选择' }
                    ],
                  },
                ]"
                placeholder="选择"
                show-search
                disabled
                option-filter-prop="children"
                :filter-option="filterOption"
              >
                <a-select-option :key="key" :value="val.id" v-for="(val, key) in sellContractList">{{ val.number }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="结算数量依据" :label-col="labelCol" :wrapper-col="wrapperCol">
              <a-input :rows="1" v-decorator="['settlement_quantity_basis', {rules: [{required: false, message: '必填项，请填写信息'}, {max:32, message: '输入超出长度限制'}]}]" placeholder="结算数量依据"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="结算数量" :label-col="labelCol" :wrapper-col="wrapperCol">
              <a-input-number :precision="4" style="width: 50%" v-decorator="['settlement_quantity', {rules: [{required: true, message: '必填项，请填写信息'}]}]" placeholder="结算数量"/>
              <a-select
                style="width: 45%; margin-left: 3px"
                v-decorator="[
                  'settlement_unit',
                  {
                    rules: [
                      { required: true, message: '请选择' },
                    ],
                  },
                ]"
                placeholder="单位"
                show-search
                option-filter-prop="children"
                :filter-option="filterOption"
              >
                <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.unit">{{ val }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="是否存在扣减项" :label-col="labelCol2" :wrapper-col="wrapperCol2">
              <a-select
                v-decorator="[
                  'has_deduction_item',
                  {
                    rules: [
                      { required: false, message: '请选择' }
                    ],
                  },
                ]"
                placeholder="选择"
                @change="hasDeductionItem"
                option-filter-prop="children"
                :filter-option="filterOption"
              >
                <a-select-option :key="key" :value="key" v-for="(val, key) in this.is_has_deduction_item">{{ val }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="24" v-if="has_deduction_item === 1">
            <a-form-item label="扣减数量" :label-col="labelCol2" :wrapper-col="wrapperCol2">
              <a-input-number :precision="4" style="width: 50%" v-decorator="['deduction_quantity', {rules: [{required: has_deduction_item === 1, message: '必填项，请填写信息'}]}]" placeholder="结算数量"/>
              <a-select
                style="width: 45%; margin-left: 3px"
                v-decorator="[
                  'unit',
                  {
                    rules: [
                      { required: has_deduction_item === 1, message: '请选择' },
                    ],
                  },
                ]"
                placeholder="单位"
                show-search
                option-filter-prop="children"
                :filter-option="filterOption"
              >
                <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.unit">{{ val }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="最终结算数量" :label-col="labelCol" :wrapper-col="wrapperCol">
              <a-input-number :precision="4" style="width: 50%" v-decorator="['final_settlement_quantity', {rules: [{required: false, message: '必填项，请填写信息'}]}]" placeholder="最终结算数量"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="结算质量依据" :label-col="labelCol" :wrapper-col="wrapperCol">
              <a-input v-decorator="['settlement_quality_basis', {rules: [{required: false, message: '必填项，请填写信息'}, {max:32, message: '输入超出长度限制'}]}]" placeholder="结算数量依据"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="结算质量" :label-col="labelCol" :wrapper-col="wrapperCol">
              <a-input-number :precision="4" style="width: 50%" v-decorator="['settlement_quality', {initialValue: 0, rules: [{required: false, message: '必填项，请填写信息'}]}]" placeholder="结算质量"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="是否存在质量扣款" :label-col="labelCol2" :wrapper-col="wrapperCol2">
              <a-select
                v-decorator="['has_quality_deduction', { rules: [{ required: false, message: '请选择' }]}]"
                placeholder="选择"
                @change="hasQualityDeduction">
                <a-select-option :key="key" :value="key" v-for="(val, key) in this.is_has_quality_deduction">{{ val }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="24" v-if="has_quality_deduction === 1">
            <a-form-item label="扣款总金额" :label-col="labelCol2" :wrapper-col="wrapperCol2">
              <a-input-number :precision="2" style="width: 50%" v-decorator="['total_deduction_amount', {rules: [{required: has_quality_deduction === 1, message: '必填项，请填写信息'}]}]" placeholder="扣款总金额"/>
              <a-select
                style="width: 45%; margin-left: 3px"
                v-decorator="[
                  'currency',
                  {
                    rules: [
                      { required: has_quality_deduction === 1, message: '请选择' },
                    ]
                  }
                ]"
                placeholder="币种"
                show-search
                option-filter-prop="children"
                :filter-option="filterOption"
              >
                <a-select-option :key="key" :value="key" v-for="(val, key) in this.currency">{{ val }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="结算币种" :label-col="labelCol" :wrapper-col="wrapperCol">
              <a-select
                v-decorator="[
                  'settlement_pricing_currency',
                  {
                    rules: [
                      { required: false, message: '请选择' }
                    ],
                  },
                ]"
                placeholder="选择"
                show-search
                @change="pricingCurrencyChange"
                option-filter-prop="children"
                :filter-option="filterOption">
                <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.currency">{{ val }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="结算单价" :label-col="labelCol" :wrapper-col="wrapperCol">
              <a-input-number :precision="2" style="width: 50%" v-decorator="['settlement_unit_price', {rules: [{required: false, message: '必填项，请填写信息'}]}]" placeholder="结算单价"/>
              <span style="padding-left: 5px">{{ this.$Dictionaries.currency[this.pricingCurrency] }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="结算汇率" :label-col="labelCol" :wrapper-col="wrapperCol">
              <a-input-number :precision="2" style="width: 50%" v-decorator="['settlement_exchange_rate', {rules: [{required: false, message: '必填项，请填写信息'}]}]" placeholder="结算汇率"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="结算金额" :label-col="labelCol" :wrapper-col="wrapperCol">
              <a-input-number :precision="2" style="width: 50%" v-decorator="['settlement_amount', {rules: [{required: false, message: '必填项，请填写信息'}]}]" placeholder="结算金额"/>
              <span style="padding-left: 5px">{{ this.$Dictionaries.currency[this.pricingCurrency] }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item v-bind="buttonCol">
              <a-row>
                <a-col offset="6" span="8">
                  <a-button type="primary" html-type="submit" @click="handleSubmit">提交</a-button>
                </a-col>
                <a-col span="10">
                  <a-button @click="handleGoBack">返回</a-button>
                </a-col>
              </a-row>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-spin>
  </a-card>
</template>

<script>
import pick from 'lodash.pick'
import { settlement_list, settlement_update, settlement_product_parameter_list } from '@/api/trade_settlement'
import { sell_contract_list } from '@/api/trade_sell_contract'
import { product_parameter_list } from '@/api/trade_product_parameter'
const fields = ['number', 'sell_contract_id', 'settlement_quantity_basis', 'settlement_quantity',
  'settlement_unit', 'has_deduction_item', 'final_settlement_quantity', 'deduction_quantity', 'unit',
  'settlement_quality_basis', 'settlement_quality', 'has_quality_deduction', 'total_deduction_amount', 'currency',
  'settlement_pricing_currency', 'settlement_unit_price', 'settlement_exchange_rate', 'settlement_amount']
export default {
  name: 'TableEdit',
  props: {
    record: {
      type: [Object, String],
      default: ''
    }
  },
  data () {
    return {
      labelCol: {
        xs: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 18 }
      },
      buttonCol: {
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12, offset: 5 }
        }
      },
      labelCol2: {
        xs: { span: 3 }
      },
      wrapperCol2: {
        xs: { span: 21 }
      },
      formLayout: 'horizontal',
      form: this.$form.createForm(this),
      id: 0,
      data: {},
      loading: false,
      projectId: undefined,
      product_name: '',
      otherData: {
        product_parameters: []
      },
      is_has_deduction_item: this.$Dictionaries.is_has,
      is_has_quality_deduction: this.$Dictionaries.is_has,
      currency: this.$Dictionaries.currency,
      has_deduction_item: 1,
      has_quality_deduction: 1,
      sellContractList: [],
      pricingCurrency: undefined,
      parameterColumns: [
        {
          title: '序号',
          width: 90,
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: '名称',
          dataIndex: 'name',
          width: 200,
          ellipsis: true
        },
        {
          title: '符号',
          dataIndex: 'symbol',
          width: 160,
          ellipsis: true,
          customRender: (text) => this.$Dictionaries.trade_value_compare_symbol[text] || '无'
        },
        {
          title: '合同值',
          dataIndex: 'standard_value',
          width: 160,
          ellipsis: true
        },
        {
          title: '实际值',
          dataIndex: 'value',
          width: 160,
          ellipsis: true,
          scopedSlots: { customRender: 'value' }
        }
      ]
    }
  },
  created () {
    fields.forEach(v => this.form.getFieldDecorator(v))
    this.loadSettlementData()
  },
  methods: {
    handleGoBack () {
      // this.$emit('onGoBack')
      this.$router.go(-1)
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    loadSettlementData () {
      this.loading = true
      settlement_list({ id: this.$route.params.id })
        .then(res => {
          console.log(res.data, '我是数据列表@')
          const list = res.data.entries
          if (list && list.length > 0) {
            this.data = list[0]
            this.projectId = this.data.project_id
            // this.loadEditInfo(this.data)
            this.handleSellContractSearch(this.data.sell_contract_id)
          }
        }).finally(() => {
          this.loading = false
      })
    },
    handleSubmit () {
      const { form: { validateFields } } = this
      validateFields((err, values) => {
        console.log('我要提交接口', values)
        if (!err) {
          // eslint-disable-next-line no-console
          console.log('Received values of form: ', values)
          if (this.otherData.product_parameters.length > 0) {
            values['product_parameters'] = this.otherData.product_parameters
          }
          settlement_update(values, this.id)
            .then((res) => {
              this.handleGoBack()
              console.log(res, '修改成功')
            })
        }
      })
    },
    handleSellContractSearch (id) {
      const project_id = this.$route.query.project_id ? this.$route.query.project_id : this.projectId
      sell_contract_list({ project_id: project_id, id: id }).then((res) => {
        const result = res.data.entries || []
        this.sellContractList = result.reduce((acc, current) => {
          if (!acc.some(item => item.number === current.number)) {
            acc.push(current)
          }
          return acc
        }, [])
      }).finally(() => {
        this.handleProductParameterList(id)
      })
    },
    loadEditInfo (data) {
      this.$nextTick(() => {
        // const { form } = this
        console.log(`将加载 ${this} 信息到表单`)
        new Promise((resolve) => {
          this.has_quality_deduction = Number(data.has_quality_deduction ? '1' : '0')
          this.has_deduction_item = Number(data.has_deduction_item ? '1' : '0')
          setTimeout(resolve, 1)
        }).then(() => {
          const formData = pick(data, fields)
          formData.unit = '' + formData.unit
          formData.settlement_pricing_currency = '' + formData.settlement_pricing_currency
          formData.has_quality_deduction = formData.has_quality_deduction ? '1' : '0'
          formData.has_deduction_item = formData.has_deduction_item ? '1' : '0'
          this.id = data.id
          this.pricingCurrencyChange(formData.settlement_pricing_currency)
          console.log('formData', formData)
          this.form.setFieldsValue(formData)
        })
      })
    },
    hasDeductionItem (value) {
      this.has_deduction_item = Number(value)
    },
    hasQualityDeduction (value) {
      this.has_quality_deduction = Number(value)
    },
    onParameterDelete (key) {
      this.otherData.product_parameters = this.otherData.product_parameters.filter(product => {
        return product.key !== key
      })
    },
    handleProductParameterList (sell_contract_id) {
      if (sell_contract_id > 0) {
        this.product_name = this.sellContractList.filter(item => item.id === sell_contract_id)[0].product_name
        product_parameter_list({ sell_contract_id: sell_contract_id }).then(res => {
          if (res.code === 1000) {
            console.log(res)
            if (res.data.entries !== undefined && res.data.entries.length > 0) {
              const current_date = new Date()
              this.otherData.product_parameters = res.data.entries.map(item => {
                item['value'] = ''
                item['key'] = item.id === undefined ? (current_date.getHours() + '' + current_date.getMinutes() + '' + current_date.getSeconds() + '' + Math.floor(Math.random() * 100000)) : item.id
                return item
              })
            }
          }
        }).finally(() => {
          settlement_product_parameter_list({ settlement_id: this.$route.params.id }).then(res => {
            if (res.code === 1000) {
              if (res.data !== undefined && res.data.entries.length > 0) {
                const pp = {}
                res.data.entries.forEach(item => {
                  pp[item.product_parameter_id] = item['value']
                })
                this.otherData.product_parameters = this.otherData.product_parameters.map(item => {
                  item['value'] = pp[item.id]
                  return item
                })
              }
            }
          })
        }).finally(() => {
          this.loadEditInfo(this.data)
        })
      }
    },
    handleItemChange (value, key, column) {
      const newData = [...this.otherData.product_parameters]
      const target = newData.find(item => key === item.key)
      if (target) {
        target[column] = value
        this.otherData.product_parameters = newData
      }
    },
    pricingCurrencyChange (value) {
      this.pricingCurrency = value
    }
  }
}
</script>
